import type { UndoRedoCommand, UndoRedoCommandSet } from '../../../generated';
import { ReactiveMap } from '../../../utils/ReactiveMap';

export const MAX_STACK_SIZE = 100;

export type UndoRedoCommandHash = {
  undos: Array<UndoRedoCommandSet>;
  redos: Array<UndoRedoCommandSet>;
  activeCommand: UndoRedoCommand;
};

export const undoRedoCommandMap = new ReactiveMap<
  string,
  UndoRedoCommandHash,
  'undoRedoCommandMap'
>('undoRedoCommandMap');
undoRedoCommandMap.set('default', {
  activeCommand: null,
  undos: [],
  redos: [],
});
